export default __webpack_public_path__ + "static/media/komald.8cfe77a7.jpeg";